import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { RegisterSearchConditionsPostRequestModel, RegisterSearchConditionsPostResponseModel } from "@/features/accounts/shared/services/register-search-conditions-model";

export class RegisterSearchConditionsApi {
  /**
   * 検索条件登録API
   */
  public registerSearchConditions = async (
    param: RegisterSearchConditionsPostRequestModel
  ): Promise<RegisterSearchConditionsPostResponseModel> => {
    const path = `/api/searchconditions`;
    const res = await ApiClient.instance.post<RegisterSearchConditionsPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
